:host {
    position: fixed;
    top: -100px;
    right: -100px;
    bottom: -100px;
    left: -100px;
    background-color: transparent;
    transition: opacity 400ms ease;
    pointer-events: none;
    z-index: 3000;
    z-index: var(--zindex-backdrop, 3000);
    opacity: 0;
}

:host([prevent-overscroll]) {
    overflow: scroll;
    overscroll-behavior: none;
}

:host([prevent-overscroll]) .backdrop {
        overflow: scroll;
        overscroll-behavior: none;
    }

:host([prevent-overscroll]) .backdrop::after {
            content: '';
            display: block;
            height: 200vh;
            width: 200vw;
        }

:host(.entering),
:host(.entered) {
    opacity: 1;
}

.backdrop {
    position: fixed;
    top: -100px;
    right: -100px;
    bottom: -100px;
    left: -100px;
    background-color: var(--color-overlay);
    opacity: var(--color-overlay-alpha);
    z-index: -1;
    pointer-events: all;
    cursor: pointer;
    overflow: hidden;
}
